<template>
  <el-dialog  
    :title="title"
    width="550px"
    :visible.sync="dialogVisible"
    @close="$emit('update:visible',false)">
    <div class="weui-cell weui-cell__priamry nobefore" v-for="(item, index) in property" :key="index">
      <div class="weui-cell__hd">{{item.explain}}：</div>
      <div class="weui-cell__bd pl10">{{item.value}}</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'afterSalesForm', 
  props: ['visible', 'property', 'title'],
  data() {
    return {
      dialogVisible: this.visible,
      form: null
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  }
}
</script>